import React, { useContext, useState } from 'react'
import profilepic from "../images/pfp.jpg";
import {db} from "../firebase";
import { collection, query, where , getDocs, setDoc, updateDoc, serverTimestamp, doc, getDoc} from 'firebase/firestore';
import {AuthContext} from "../context/AuthContext";

const Search = () => {

  const [username,setUsername] = useState("");
  const [user,setUser] = useState(null);
  const [err,setErr] = useState(false);

  const {currentUser}= useContext(AuthContext);

  const handleSearch = async () => {
  const q= query(collection(db, "users"), where("displayName", "==" , username));

  try{
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      setUser(doc.data());
    });
    setErr(false);
  }catch(err){
    setErr(true);
  }
  };

  const handleKey = e=>{
    e.code=="Enter"  && handleSearch();
  };

  const handleSelect = async () =>{
    //check whether the group(chats in firestore) exists , if not create new
    const combinedId= currentUser.uid>user.uid ? currentUser.uid + user.uid : user.uid + currentUser.uid;

    try{
    const res= await getDoc(doc(db,"chats",combinedId));
    if(!res.exists()){
      //create a chat in chats collection
      await setDoc(doc(db,"chats",combinedId),{
        messages:[]
      });

      //create userchats
      await updateDoc(doc(db,"userChats",currentUser.uid),{
        [combinedId+".userInfo"]:{
          uid:user.uid,
          displayName:user.displayName,
          photoURL:user.photoURL
        },
        [combinedId+".date"]:serverTimestamp()
      });

      await updateDoc(doc(db,"userChats",user.uid),{
        [combinedId+".userInfo"]:{
          uid:currentUser.uid,
          displayName:currentUser.displayName,
          photoURL:currentUser.photoURL
        },
        [combinedId+".date"]:serverTimestamp()
      });
    }
    }catch(err){}
    
    setUser(null);
    setUsername("");
  }

  return (
    <div className='search'>
      <div className="searchForm">
        <input type="text" placeholder='Search a user' onKeyDown={handleKey} onChange={e=>setUsername(e.target.value)}
        value={username}/>
      </div>
      {err && <span>User doesn't exist</span>}
      {user && <div className='userChat' onClick={handleSelect}>
        <img src={user.photoURL} alt="profile pic" />
        <div className='userChatInfo'>
          <span>{user.displayName}</span>
        </div>
      </div>}
    </div>
  )
}

export default Search